import React, { useState } from 'react';
import { useEffect } from 'react';

const LoginScreen = ({ onLogin }) => {
  const [sdkLoaded , setSdkLoaded] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');


  const handleLogin = () => {

    return username + `님이 로그인에 성공하였습니다.` + password
  };

  const style = {
    margin : '0 auto',
    padding : '50px',
    backgroundColor : 'red',
    width : '200px',
    height : '200px'
  }

  return (
    <>

      <div style={style} id='login-sdk-container'>
        <h2>9bin Login Screen</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>
      </div>
    </>
  );
};

export default LoginScreen;
